import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { PackageModel } from 'src/app/model/stripe-models/product/package-model';
import { Router } from '@angular/router';
import { UserLocalSelectionService } from 'src/app/services/dataServices/user-local-selection-service/user-local-selection.service';
import { AuthService } from 'src/app/services/auth-service/auth.service';

@Component({
    selector: 'app-tarife-card',
    templateUrl: './tarife-card.component.html',
    styleUrls: ['./tarife-card.component.scss'],
    standalone: false
})
export class TarifeCardComponent implements OnInit {
  @Input() plan!: PackageModel;
  @Input() loggedIn!: boolean;
  @Input() ProductsToShow: PackageModel[];
  constructor(private dialogService: DialogService,
    public router: Router,
    private localSelectionService: UserLocalSelectionService,
    private auth: AuthService
  ) { }

  ngOnInit(): void {

  }

  public showTarifeSelectionDialog(id, name, ProductsToShow ) {
    this.dialogService.openTarifeSelectionDialog(id, name, ProductsToShow).subscribe((result) => {
      if(typeof result === 'number') {
        this.router.navigate([`organisations/${result}/abonnements`]);
      }
    });
  }

  showLoginDialog(selPlan: PackageModel) {
    if(selPlan) {
      this.localSelectionService.setSelection(selPlan, 'selectedPackage');
    }
    this.dialogService.openLoginDialog().subscribe((result) => {
      if (result === 'success') {
        this.localSelectionService.clearSelection('selectedPackage');
        this.showTarifeSelectionDialog(selPlan.priceId.id, selPlan.packageClass, this.ProductsToShow );
      } else if (result === 'error') {
        this.dialogService.openDialog('Ein Fehler ist aufgetreten.', 'Bitte versuchen Sie es später erneut.');
      }
      else if(result + "" == "" || result == undefined) this.localSelectionService.clearSelection('selectedPackage');
    });
  }

  login(): void {
    this.router.navigate(['login']);
  }
}
